// The Inkglish logo mark: your voice in a speech bubble, with the AI spark (Ink, the AI teacher, speaking).
// Drawn for an amber tile (`.dot` in the sidebar, `.logo` on sign-in): the bubble takes the text color, the bars and spark the brand.
const BUBBLE =
  'M28 18H72A16 16 0 0 1 88 34V58A16 16 0 0 1 72 74H34L18 87C17 88 15 87 16 85L20 74H28A16 16 0 0 1 12 58V34A16 16 0 0 1 28 18Z';
const VOICE =
  'M31 39.2A3 3 0 0 1 37 39.2V52.8A3 3 0 0 1 31 52.8ZM39.5 33.6A3 3 0 0 1 45.5 33.6V58.4A3 3 0 0 1 39.5 58.4Z' +
  'M48 29.4A3 3 0 0 1 54 29.4V62.6A3 3 0 0 1 48 62.6ZM56.5 37.8A3 3 0 0 1 62.5 37.8V54.2A3 3 0 0 1 56.5 54.2Z' +
  'M65 33.6A3 3 0 0 1 71 33.6V58.4A3 3 0 0 1 65 58.4Z' +
  'M79 23.5C79.91 29.09 79.91 29.09 85.5 30C79.91 30.91 79.91 30.91 79 36.5C78.09 30.91 78.09 30.91 72.5 30C78.09 29.09 78.09 29.09 79 23.5Z';

export function BrandMark() {
  return (
    <svg className="ic" viewBox="10 14 80 76" aria-hidden="true">
      <path d={BUBBLE} fill="currentColor" />
      <path d={VOICE} fill="var(--brand)" />
    </svg>
  );
}
